<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div class="col-md-12">
      <div class="page-breadcrumb"><!-- new -->
        <ul class="page-breadcrumb__trail">
          <li><a>Manage</a></li>
          <li><a>Sections</a></li>
        </ul>
        <div class="page-breadcrumb__icons">
          <a routerLink="/home"><img src="assets/images/New_Icons/home-transprent-icon.svg" title="Home" alt="Home icon"></a>
        </div>
      </div>
      <div class="block">
        <div class="page-header"> <!--changed new-->
          <span class="page-header__title">Sections</span>
          <img src="assets/images/New_Icons/refresh-icon.svg" alt="Refresh icon" title="Refresh" class="page-header__icon" width="17" height="17" (click)="!enableDisablePageLoader ? ngOnInit() : null"/>
        </div>
        <div class="list_block">
          <div class="toolbar"> <!--search and new changed new-->
            <div class="toolbar__search">
              <img src="../../../../../../assets/images/New_Icons/search-icon.svg" alt="Search icon">
              <input type="text" (ngModelChange)="onSearchChanged()" [(ngModel)]="search" name="search" autocomplete="off" placeholder="Search by section"/>
            </div>
            <div class="toolbar__spacer"></div>
            <div class="toolbar__add-button" (click)="openForm()">
              <button type="button">
                <span class="toolbar__add-icon">
                  <img src="../../../../../../assets/images/New_Icons/plus-icon.svg" alt="Add Icon"/>
                </span>
                <span class="toolbar__add-text">Add New</span>
              </button>
            </div>
          </div>
        </div>
        <div *ngIf="enableDisablePageLoader">
          <div class="adjust">
            <div class="loader2"></div>
          </div>
        </div>
        <div class="cards_container" *ngIf="!enableDisablePageLoader">
          <div class="card_wrapper" *ngFor="let section of sectionsList; let i = index">
            <div class="master-card">
              <div class="master-card-header">
                <div class="master-card-title">
                  <img src="../../../../../../assets/images/New_Icons/card-heading.svg" alt="Left arrow icon">
                  <span>{{ section && section.section_name }}</span>
                </div>
              </div>
              <div class="master-card-body">
                <div class="master-card-body-info">
                  <span class="card-content-text">Location:</span>
                  <span class="text">{{section?.farmsiteDetails?.farmNameAtLocation }}</span>
                </div>
                <div class="master-card-body-info">
                  <span class="card-content-text">Created At:</span>
                  <span class="text">{{ section?.createdAt | date: "dd MMM yyyy" }}</span>
                </div>
              </div>
              <div class="master-card-footer">
                <div class="master-card-footer-info">
                  <span class="label">Updated At:</span>
                  <span class="text">{{ section?.updatedAt | date: "dd MMM yyyy" }}</span>
                </div>
                <div class="action-icons">
                  <a>
                    <img src="../../../../../../assets/images/New_Icons/edit.svg" alt="Edit icon" title="Edit Business Type" (click)="getSectionById(section.id)">
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="listLoader" class="loader-div">
          <div class="adjust">
            <div class="loader2 list-loader"></div>
          </div>
        </div>
        <div *ngIf="noList && !enableDisablePageLoader" class="noDataFoundMessage">Section Not Found</div>
        <!--sensor types block end-->
      </div>
      <!--add/update form-->
      <div class="dynamic-form-wrapper" [ngClass]="{ 'floating-panel': formFieldCount <= 7, 'slide-in-overlay': formFieldCount > 7}" *ngIf="showForm">
        <!--<div *ngIf="formFieldCount > 7" class="overlay-background" (click)="closeForm()"></div>-->
        <!--outside close-->
        <div class="popup-wrapper">
          <button type="button" class="popup-close-beside" (click)="clear()" title="Close">&times;</button>
          <!-- Actual Popup -->
          <div [ngClass]="{ 'form-container-panel': formFieldCount > 7, 'popup-inner': formFieldCount <= 7}">
            <form [formGroup]="registerForm" novalidate>
              <div class="form-header">
                <div class="form-title">Sections</div>
                <button class="add-update-submit-button" (click)="addUpdateSection()" [disabled]="sensorDoubleClick">
                  <span class="icon"><img src="../../../../../../assets/images/New_Icons/tick-icon.svg" alt="Tick icon"></span>
                  <span class="text">{{ submitButton ? 'Submit' : 'Update' }}</span>
                </button>
              </div>
              <div class="form-container">
                <!--  Location -->
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Location</mat-label>
                  <mat-select id="sitename" formControlName="farm_site_id">
                    <mat-option value="" disabled>Select Location</mat-option>
                    <mat-option *ngFor="let loc of farmsites" [value]="loc.id"> {{ loc.farmNameAtLocation }} </mat-option>
                  </mat-select>
                  <mat-hint *ngIf="f.farm_site_id.invalid"><i>Select Location</i></mat-hint>
                  <mat-hint *ngIf="f.farm_site_id.valid"><i>Location Selected</i></mat-hint>
                  <mat-error *ngIf="(f.farm_site_id.touched || f.farm_site_id.dirty || submitted) && f.farm_site_id.hasError('required')">
                    <i>Required.</i>
                  </mat-error>
                </mat-form-field>
                <!--Name-->
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Name</mat-label>
                  <input matInput id="activityName" type="text" formControlName="section_name" autocomplete="off" placeholder="Enter name"/>
                  <!-- Hint -->
                  <mat-hint><i>3–20 alphabetic characters</i></mat-hint>
                  <!-- Single dynamic error -->
                  <mat-error *ngIf="(f.section_name.dirty || f.section_name.touched || submitted) && f.section_name.errors">
                    <i> {{f.section_name.hasError('required') ? 'Name is required.': f.section_name.hasError('minlength')? 'Minimum 3 characters required.': f.section_name.hasError('maxlength')
                      ? 'Maximum 20 characters allowed.' : f.section_name.hasError('pattern') ? 'Only alphabets allowed.': ''}}</i>
                  </mat-error>
                </mat-form-field>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!--add/update form end-->
    </div>
  </div>
</div>
